export const filterHasValue = (filter: any): boolean => (
    (filter.min !== undefined && filter.min !== '') ||
    (filter.max !== undefined && filter.max !== '') ||
    (filter.exact !== undefined && filter.exact !== '') ||
    (filter.percentage !== undefined && filter.percentage !== '') ||
    (filter.variance !== undefined && filter.variance !== '')
  )
